import { MotorcycleDetails } from 'Api/insurance';
import { mapMotorcycleCoverageToText } from 'Components/InsuranceDetailsSections/mappers/products/mapMotorcycleToInsuranceDetailsView';
import { VehicleCoverage } from 'Types/coverages/coverages.types';
import { UsabilityCode } from '../changeMotorcycleForm.constants';

export const canChangeOwnContribution = (coverage: string): boolean => {
  return coverage === VehicleCoverage.FULL_OWN_DAMAGE;
};

export const mapUsabilityCodeFromBackend = (
  backendValue: string,
): UsabilityCode => {
  switch (backendValue) {
    case 'notUnder24':
    case 'youngDriver':
      return UsabilityCode.YOUNG_DRIVER;
    case 'notUnder35':
    case 'adultDriver':
      return UsabilityCode.ADULT_DRIVER;
    case 'allAges':
      return UsabilityCode.ALL_AGES;
    default:
      return UsabilityCode.ALL_AGES;
  }
};

export const customerWantsToUpgradeCoverage = (
  insurance: MotorcycleDetails,
  coverageValue: VehicleCoverage,
): boolean => {
  const initialCoverage = mapMotorcycleCoverageToText(
    insurance.coverage as VehicleCoverage,
  );
  const newCoverage = mapMotorcycleCoverageToText(coverageValue);

  return (
    wantsToUpgradeFromDelkaskoToKasko(initialCoverage, newCoverage) ||
    wantsToUpgradeFromAnsvarToDelkasko(initialCoverage, newCoverage) ||
    wantsToUpgradeFromAnsvarToKasko(initialCoverage, newCoverage)
  );
};

const wantsToUpgradeFromAnsvarToKasko = (
  initialCoverage: string,
  newCoverage: string,
): boolean => initialCoverage === 'Ansvar' && newCoverage === 'Kasko';

const wantsToUpgradeFromAnsvarToDelkasko = (
  initialCoverage: string,
  newCoverage: string,
): boolean => initialCoverage === 'Ansvar' && newCoverage === 'Delkasko';

const wantsToUpgradeFromDelkaskoToKasko = (
  initialCoverage: string,
  newCoverage: string,
): boolean => initialCoverage === 'Delkasko' && newCoverage === 'Kasko';

export const isDowngradingMcCoverage = (
  initialCoverage: string,
  newCoverage: string,
): boolean =>
  (initialCoverage === VehicleCoverage.FULL_OWN_DAMAGE &&
    newCoverage !== VehicleCoverage.FULL_OWN_DAMAGE) ||
  (initialCoverage === VehicleCoverage.REDUCED_OWN_DAMAGE &&
    newCoverage === VehicleCoverage.DRIVER_AND_PASSENGER_ACCIDENT);

export const isMcUpgradingCoverage = (
  initialCoverage: string,
  newCoverage: string,
): boolean => {
  return (
    (initialCoverage !== VehicleCoverage.FULL_OWN_DAMAGE &&
      newCoverage === VehicleCoverage.FULL_OWN_DAMAGE) ||
    (initialCoverage === VehicleCoverage.DRIVER_AND_PASSENGER_ACCIDENT &&
      newCoverage === VehicleCoverage.REDUCED_OWN_DAMAGE)
  );
};

export const isKaskoCoverage = (coverage: string): boolean =>
  coverage.toLowerCase() === VehicleCoverage.FULL_OWN_DAMAGE.toLowerCase();

export const isAnsvarCoverage = (coverage: string): boolean =>
  coverage.toLowerCase() ===
  VehicleCoverage.DRIVER_AND_PASSENGER_ACCIDENT.toLowerCase();

export const isDelkaskoCoverage = (coverage: string): boolean =>
  coverage.toLowerCase() === VehicleCoverage.REDUCED_OWN_DAMAGE.toLowerCase();
